import { SWRConfiguration } from 'swr';

import { EmployeeCollaborationTaskList } from '~/data/collaboration/types';
import { useArraySWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

const getEmployeeCollaborationWorkLists = (
  employeeId: number,
  language?: string,
): Promise<EmployeeCollaborationTaskList[]> => {
  const resolveParams = (): string => {
    const params: string[] = [];

    if (!!language) {
      params.push(`langIso=${language}`);
    }

    return params.length > 0 ? `?${params.join('&')}` : '';
  };

  return fetchFromOldApi(
    `/json/employee/${employeeId}/worklists${resolveParams()}`,
  ).then((r) => r.json());
};

export const useGetEmployeeCollaborationWorkLists = (
  args: {
    employeeId?: number;
    language?: string;
  },
  swrConfig?: SWRConfiguration,
) => {
  const { employeeId, language } = args;

  return useArraySWR(
    !!employeeId
      ? ['getEmployeeCollaborationWorkLists', employeeId, language]
      : null,
    ([_key, employeeId, language]: [string, number, string | undefined]) =>
      getEmployeeCollaborationWorkLists(employeeId, language),
    swrConfig,
  );
};
